/**
 * Chat recovery (جایگزینی پزشک) — shared types.
 *
 * Contract with the ov-booking-control `/v1/chat-recovery/suggestion` endpoint
 * (design: ardani-repo docs/work/ov-chat-recovery-design-2026-10-03.md §4).
 * The server is the source of truth for eligibility (2h rule, allowlist, voids);
 * this module only renders what the server offers and never invents a candidate.
 */

export interface RecoveryBook {
  book_id: string;
  ref_id: string;
  center_id: string;
  /** Visit start, unix seconds. */
  from: number;
}

export interface RecoveryDoctor {
  user_id: string;
  name: string;
}

export interface RecoveryCandidate {
  user_center_id: string;
  user_id: string;
  slug: string;
  /** Absolute or root-relative profile url, e.g. `/dr/<slug>/`. */
  profile_url: string;
  name: string;
  expertise: string;
  image?: string;
  price_current: number;
  price_candidate: number;
  /** First free turn, unix seconds. */
  slot_from: number;
  /** Pre-formatted, e.g. «امروز ۱۸:۴۵ (۲۰ دقیقه دیگر)». */
  slot_text: string;
  /** Pre-formatted, e.g. «معمولاً زیر ۳۰ دقیقه». */
  wait_time_text: string;
  satisfaction?: number;
}

export type RecoveryStateName = 'offered' | 'none' | 'voided';

export interface SuggestionResponse {
  status: number;
  result: {
    state: RecoveryStateName;
    void_reason?: string;
    minutes_overdue?: number;
    book?: RecoveryBook;
    doctor?: RecoveryDoctor;
    candidate?: RecoveryCandidate | null;
  };
}

/** Prices are tomans; the server owns the number, we own the display. */
export function formatToman(value: number): string {
  return `${value.toLocaleString('fa-IR')} تومان`;
}
